<template>
  <v-btn
    v-bind="$props"
    v-on="$listeners"
    icon
    plain
    @click="$emit('click:edit-item', $attrs.item)"
    >
    <slot>
    <v-icon color="blue">{{ $icons.edit }}</v-icon>
    </slot>
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
  name: 'EditItemAction',
  extends: VBtn,
}
</script>

